module.exports = __webpack_public_path__ + "img/cover-8.0d5632ff.jpg";